import { forwardRef, LegacyRef } from 'react';
import * as styles from '../icon.styles';
import type { IconProps } from '../icon.model';
const UsersAltIcon = forwardRef(({
  title,
  titleId,
  color,
  borderRadius,
  ...props
}: IconProps, ref?: LegacyRef<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={props.width} height={props.height} role="img" aria-hidden="true" className={styles.icon({
  ...props,
  borderRadius,
  color
})} ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M15.105 3.023a1 1 0 0 1 1.34-.45 5.5 5.5 0 0 1 0 9.855 1 1 0 0 1-.89-1.791 3.5 3.5 0 0 0 0-6.274 1 1 0 0 1-.45-1.34m1.984 13.331a1 1 0 0 1 1.323-.499c1.678.76 3.162 1.984 4.374 3.527a1 1 0 1 1-1.572 1.236c-1.043-1.327-2.281-2.332-3.626-2.94a1 1 0 0 1-.5-1.324" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M4 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0M1.214 19.382C3.305 16.72 6.217 15 9.5 15s6.195 1.72 8.286 4.382A1 1 0 0 1 17 21H2a1 1 0 0 1-.786-1.618" clipRule="evenodd" /></svg>);
UsersAltIcon.displayName = "UsersAltIcon";
export default UsersAltIcon;